import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import getDecodeDescription from "../../services/decodeText";
import { propsNamesAdapter } from "../../services/propsNamesAdapter";
import StepsForm from "../StepsForm/StepsForm";
import {
  checkIsValidFormSteps,
  updateErrorsFormSteps,
} from "../../services/manageValidation";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import { ModalConsumer } from "../../common/ModalContext";
import ModalAdditionResult from "../../components/ModalAdditionResult/ModalAdditionResult";
import hotSpotStyles from "../HotSpotForm/HotSpotForm.module.scss";

const HotSpotForm = ({ handleSubmit, spotToEdit, stepStatus, type }) => {
  useEffect(() => {
    if (
      spotToEdit.type &&
      spotToEdit.type !== "hotSpot" &&
      spotToEdit.type !== "greenSpot"
    ) {
      return;
    }

    if (!spotToEdit) {
      return;
    }
    setName(spotToEdit.name);
    setCountries(spotToEdit.countries);
    spotToEdit.address && setAddress(spotToEdit.address);
    spotToEdit.key && setKey(spotToEdit.key);
    spotToEdit.links && !spotToEdit.links.length
      ? setLinks([{}])
      : setLinks(spotToEdit.links);
    spotToEdit.email && setEmail(spotToEdit.email);
    setHotSpotFields(spotToEdit.fields);
    spotToEdit.relatedOrganizations && !spotToEdit.relatedOrganizations.length
      ? setRelatedOrganizations([{}])
      : setRelatedOrganizations(spotToEdit.relatedOrganizations);
    spotToEdit.photos && !spotToEdit.photos.length
      ? setPhotos([{}])
      : setPhotos(spotToEdit.photos);
    spotToEdit.videos && !spotToEdit.videos.length
      ? setVideos([{}])
      : setVideos(spotToEdit.videos);
    spotToEdit.titleSeo && setTitleSeo(spotToEdit?.titleSeo);
    spotToEdit.descriptionSeo && setDescriptionSeo(spotToEdit?.descriptionSeo);
    spotToEdit.timeline && !spotToEdit.timeline.length
      ? setTimeline([{}])
      : setTimeline(
          spotToEdit.timeline?.map((item) =>
            Object.keys(item).length
              ? { ...item, text: getDecodeDescription(item.text) }
              : {}
          )
        );
    spotToEdit?.problem && !spotToEdit?.problem?.length
      ? setProblem([{}])
      : setProblem(
          spotToEdit?.problem?.map((item) =>
            Object.keys(item).length
              ? { ...item, text: getDecodeDescription(item.text) }
              : {}
          )
        );
    spotToEdit?.solutions && !spotToEdit.solutions.length
      ? setSolutions([{}])
      : setSolutions(
          spotToEdit?.solutions?.map((item) =>
            Object.keys(item).length
              ? { ...item, text: getDecodeDescription(item.text) }
              : {}
          )
        );
    spotToEdit?.faq && !spotToEdit.faq.length
      ? setFaq([{}])
      : setFaq(
          (spotToEdit?.faq || [{}]).map((item) =>
            Object.keys(item).length
              ? {
                  ...item,
                  answer: getDecodeDescription(item.answer || item.text || ""),
                }
              : {}
          )
        );
  }, [spotToEdit]);

  ///USE CUSTOM HOOK
  const [countries, setCountries] = useState([]);
  const [hotSpotFields, setHotSpotFields] = useState([]);
  const [validationError, setValidationError] = useState([]);
  const [photos, setPhotos] = useState([{}]);
  const [relatedOrganizations, setRelatedOrganizations] = useState([{}]);
  const [name, setName] = useState("");
  const [links, setLinks] = useState([{}]);
  const [key, setKey] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [problem, setProblem] = useState([{}]);
  const [solutions, setSolutions] = useState([{}]);
  const [timeline, setTimeline] = useState([{}]);
  const [faq, setFaq] = useState([{}]);
  const [videos, setVideos] = useState([{}]);
  const [titleSeo, setTitleSeo] = useState("");
  const [descriptionSeo, setDescriptionSeo] = useState("");

  const changeValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };

  const removeEmptyObject = (arr) => {
    const result = arr?.filter((element) => {
      if (Object.keys(element).length !== 0) return true;
      return false;
    });
    return result;
  };

  const manageNextStep = (step, toggleModal) => {
    const state = {
      name,
      countries,
      address,
      hotSpotFields,
      email,
      photos,
      relatedOrganizations,
      links,
      problem,
      solutions,
      timeline,
      faq,
      videos,
      type: type,
    };

    if (!checkIsValidFormSteps({ state, step })) {
      updateErrorsFormSteps({
        state,
        step,
        setValidationError,
      });
      return false;
    }
    if (step === 3 && checkIsValidFormSteps({ state, step })) {
      handleSubmit({
        toggleModal,
        name,
        author: spotToEdit?.author,
        countries,
        address,
        hotSpotFields,
        type: type,
        status: "onreview",
        photos: removeEmptyObject(photos),
        relatedOrganizations: removeEmptyObject(relatedOrganizations),
        links: removeEmptyObject(links),
        problem: removeEmptyObject(problem),
        solutions: removeEmptyObject(solutions),
        timeline: removeEmptyObject(timeline),
        faq: removeEmptyObject(faq),
        videos: removeEmptyObject(videos),
        titleSeo,
        descriptionSeo,
        key: spotToEdit?.key,
        originalId: spotToEdit?.originalId || spotToEdit?._id,
        originalType: spotToEdit?.originalType || type,
        _id: spotToEdit?._id,
        setName,
        setCountries,
        setAddress,
        setHotSpotFields,
        setPhotos,
        setRelatedOrganizations,
        setLinks,
        setProblem,
        setSolutions,
        setTimeline,
        setFaq,
        setVideos,
        setValidationError,
        setTitleSeo,
        setDescriptionSeo,
        setGreenSpotFields: () => {},
      });
    }
    return true;
  };
  const changeMultipleFieldsObject = (
    itemName,
    itemValue,
    index,
    setState,
    items
  ) => {
    const key = propsNamesAdapter(itemName);
    const source = Array.isArray(items) ? items : [{}];
    let updatedItems = source.map((item, i) =>
      i === index ? { ...item, [key]: itemValue } : item
    );
    const current = updatedItems[index] || {};
    if (Object.values(current).every((i) => i === "")) {
      if (updatedItems.length === 1) {
        updatedItems = [{}];
      } else {
        updatedItems = updatedItems.filter((_, i) => i !== index);
      }
    }
    setState(updatedItems);
  };

  const addFieldObject = (setState, items) => {
    const updatedItems = [...items];
    updatedItems.push({});
    setState(updatedItems);
  };

  const firstStepState = {
    countries,
    setCountries,
    hotSpotFields,
    setHotSpotFields,
    name,
    setName,
    address,
    setAddress,
    problem,
    setProblem,
    solutions,
    setSolutions,
    addFieldObject,
    validationError,
    setValidationError,
    changeMultipleFieldsObject,
    changeValidationError,
    type,
  };

  const secondStepState = {
    timeline,
    setTimeline,
    addFieldObject,
    validationError,
    setValidationError,
    changeMultipleFieldsObject,
    changeValidationError,
    type,
  };

  const thirdStepState = {
    photos,
    setPhotos,
    links,
    setLinks,
    videos,
    setVideos,
    relatedOrganizations,
    setRelatedOrganizations,
    faq,
    setFaq,
    validationError,
    setValidationError,
    changeMultipleFieldsObject,
    changeValidationError,
    addFieldObject,
    titleSeo,
    setTitleSeo,
    descriptionSeo,
    setDescriptionSeo,
    type,
  };
  return (
    <div className={hotSpotStyles.container}>
      <StepsForm
        type={type}
        manageNextStep={manageNextStep}
        firstStepFields={<FirstStep state={firstStepState} />}
        secondStepFields={<SecondStep state={secondStepState} />}
        thirdStepFields={<ThirdStep state={thirdStepState} />}
        stepsAmount={3}
        resetStep={stepStatus}
      />
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            <>
              {modalId === "organization" && (
                <ModalAdditionResult
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  content="You've added a spot"
                />
              )}

              {modalId === "wrongAddress" && (
                <ModalAdditionResult
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  content="Address is wrong. Please change the address and try again"
                />
              )}
            </>
          );
        }}
      </ModalConsumer>
    </div>
  );
};

HotSpotForm.propTypes = {
  lng: PropTypes.object,
  handleSubmit: PropTypes.func,
  type: PropTypes.string,
  spotToEdit: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  clearAll: PropTypes.func,
  isSpotEditor: PropTypes.bool,
};

export default HotSpotForm;
